import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { siteSettingsAPI } from '../services/api';
import './HeroSection.css';

const HeroSection = ({ selectedBrand, onBrandChange }) => {
  const [heroBg, setHeroBg] = useState('');

  useEffect(() => {
    siteSettingsAPI.get('hero_background_url')
      .then(res => { if (res.success) setHeroBg(res.data.hero_background_url || ''); })
      .catch(() => {});
  }, []);
  const heroContent = {
    veloura: {
      title: 'VELOURA',
      subtitle: "Los Santos' Newest Emerging Creative Hub",
      tagline: ''
    },
    vague: {
      title: 'VAGUE',
      subtitle: 'Alt Streetwear & Wearable Art',
      tagline: 'Where Fashion Meets Culture'
    }
  };

  const content = heroContent[selectedBrand];

  const scrollToNextSection = () => {
    const sections = document.querySelectorAll('section[id]');
    const heroSection = document.getElementById('home');

    if (!heroSection) return;

    let foundHero = false;
    for (let i = 0; i < sections.length; i++) {
      if (sections[i] === heroSection) {
        foundHero = true;
        continue;
      }
      if (foundHero) {
        const targetSection = sections[i];
        const startPosition = window.pageYOffset;
        const targetPosition = targetSection.getBoundingClientRect().top + window.pageYOffset;
        const distance = targetPosition - startPosition;
        const duration = 1200;
        let startTime = null;

        const easeInOutCubic = (t) => {
          return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
        };

        const animateScroll = (currentTime) => {
          if (startTime === null) startTime = currentTime;
          const timeElapsed = currentTime - startTime;
          const progress = Math.min(timeElapsed / duration, 1);
          const easedProgress = easeInOutCubic(progress);

          window.scrollTo(0, startPosition + distance * easedProgress);

          if (progress < 1) {
            requestAnimationFrame(animateScroll);
          }
        };

        requestAnimationFrame(animateScroll);
        break;
      }
    }
  };

  return (
    <section
      id="home"
      className="hero"
      data-scroll-section
      style={heroBg ? {
        backgroundImage: `url(${heroBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      } : undefined}
    >
      <div className="hero-content">
        {}
        <div className="hero-brand-selector">
          <motion.h1
            className="hero-title-brand"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <button
              className={`hero-brand-option ${selectedBrand === 'veloura' ? 'active' : ''}`}
              onClick={() => onBrandChange('veloura')}
            >
              <motion.img
                src="https://i.ibb.co/0jgdc2bV/Veloura-Inc-Logo2-Cropped.png"
                alt="Veloura"
                className="hero-brand-logo-image"
                animate={selectedBrand === 'veloura'
                  ? { opacity: 1, scale: 1 }
                  : { opacity: 0.5, scale: 0.96 }
                }
                transition={{ duration: 0.3 }}
              />
            </button>

            {}
            {
}
          </motion.h1>
        </div>
        {}
        <motion.p
          key={`${selectedBrand}-subtitle`}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.6, delay: 0.7 }}
          className="hero-subtitle"
        >
          {content.subtitle}
        </motion.p>
        {}
        <motion.div
          key={`${selectedBrand}-main-divider`}
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          exit={{ scaleX: 0 }}
          transition={{ duration: 0.8, delay: 0.9 }}
          className="hero-divider"
        />
        {}
        <motion.p
          key={`${selectedBrand}-tagline`}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.6, delay: 1.1 }}
          className="hero-tagline"
        >
          {content.tagline}
        </motion.p>
      </div>
      <div className="hero-scroll-indicator" onClick={scrollToNextSection}>
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 1.5, repeat: Infinity }}
          className="scroll-arrow"
        >
          ↓
        </motion.div>

      </div>

    </section>

  );
};

export default HeroSection;
